import React, { useEffect, useState } from 'react'
import responseMessageServices from '../../responseMessageServices';
import { useAlert } from '../../../../../context/AlertContext';
import { LinearProgress } from '@mui/material';

function ImageMessageForm({data,callBack}) {
	const {AppAlert} = useAlert();
	const [title,setTitle] = useState(""); 
    const [mediaLink,setMediaLink] = useState("");
	const [caption,setMessageBody] = useState("");
	const [saving,setSavingStatus] = useState(false);
	
	const autoFillData = ()=>{
		if(data){
			setTitle(data.title)
			setMediaLink(data.formValues.mediaLink);
            setMessageBody(data.formValues.caption);
		}
	}
	useEffect(()=>{
		autoFillData();
	},[data])

	const prepareImageResponse = () =>{
		let _responseMessage = {
			"link": mediaLink,
            "caption": caption
		}
		return _responseMessage;
	}

	const prepareWhatsAppResponse = () =>{
		let _whatsAppResponse = {
			"messaging_product": "whatsapp",
    		"recipient_type": "individual",
			"type": "image",
			"image":prepareImageResponse()
		}
		return JSON.stringify(_whatsAppResponse);
	}

	const prepareFormValues = () =>{
		let _formValues = {
			caption:caption,
            mediaLink:mediaLink
		}
		return JSON.stringify(_formValues);
	}

	const onSubmit = () =>{

		let payload = {
			"title":title,
			"messageType":"imageMessage",
			"whatsAppResponse": prepareWhatsAppResponse(),
			"formValues":prepareFormValues()
		}

		if(data){
			payload.id = data.id;
		}
		setSavingStatus(true);
		responseMessageServices.save(payload).then(res=>{
			AppAlert(res.msg)
			if(data){
				callBack(data.id);
			} else{
				callBack(res.id)
			}
			
		}).catch(error=>{
			AppAlert(error.msg,"error");
		}).finally(()=>{
			setSavingStatus(false);
		})
	}

    return (
		<div className='row'>
			<div className='col-md-9'>
				<div className='card'>
					<div className='card-header'>Text Message Response</div>
					<div className='card-body'>
						<div className='row'>
							<div className='col-md-6'>
								<div className="form-floating mb-3">
									<input type="text" className="form-control" placeholder="" value={title}  onChange={(e)=>setTitle(e.target.value)}/>
									<label>Message Title (For Admin / Manager Use) *</label>
								</div>
							</div>
							<div className='col-md-12'>
							<div className="form-floating">
                                <div className="form-floating mb-3">
									<input type="text" className="form-control" placeholder="" value={mediaLink}  onChange={(e)=>setMediaLink(e.target.value)}/>
									<label>Media URL (*)</label>
								</div>
								<div className="form-floating">
									<textarea className="form-control" placeholder="" style={{height:"100%"}} 
										value={caption}  onChange={(e)=>setMessageBody(e.target.value)}
									></textarea>
									<label>Message *</label>
								</div>
							</div>
							</div>
						</div>
					</div>
					<div className='card-footer'>
						{saving ? 
							<LinearProgress/>
							:
							<button disabled={title == "" || caption == "" || mediaLink == ""} className='btn btn-primary float-end' onClick={onSubmit} >Save</button>
						}
					</div>
				</div>
			</div>
			<div className='col-md-3'>
				<h3 className='mx-3'>Preview</h3>
				<div className='bg-light border border-dark rounded p-2 mx-3 ps-5' style={{height:"70vh"}}>
					<div className='card'>
						{mediaLink !== "" && <img src={mediaLink} className="card-img-top"/> }
						<div className='card-body'>
							{caption}
						</div>
					</div>
				</div>
			</div>
		</div>
    	
    )
}

export default ImageMessageForm